import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Modal from 'common/modal';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    color: '#1C2541',
    width: '100%',
    height: 300,
    borderRadius: 16,
    marginTop: 90,
  },
  title: {
    marginTop: 30,
    fontWeight: 700,
    fontSize: 32,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 16,
    marginTop: 10,
    textAlign: 'center',
  },
}));

type Props = {
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

const TemplateProcessingModal = ({ setShowModal, showModal }: Props) => {
  const classes = useStyles();

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={() => setShowModal(false)}
      showModal={showModal}
      showActions={false}
      content={
        <div className={classes.container}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item>
              <CircularProgress size={60} />
              <Typography className={classes.title}>Hold tight..</Typography>
              <Typography className={classes.subtitle}>Document generation in progress</Typography>
            </Grid>
          </Grid>
        </div>
      }
      overrideDialogStyles={{ width: 400, margin: 'auto', height: 496 }}
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
};

export default TemplateProcessingModal;
